/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Configuration Info
 * @export
 * @interface ConfigurationInfo
 */
export interface ConfigurationInfo {
    /**
     * Type of configuration info
     * @type {string}
     * @memberof ConfigurationInfo
     */
    configuratorType?: string;
    /**
     * Status of configuration info
     * @type {string}
     * @memberof ConfigurationInfo
     */
    status?: string;
    /**
     * Label of configuration info
     * @type {string}
     * @memberof ConfigurationInfo
     */
    configurationLabel?: string;
    /**
     * Value of configuration info
     * @type {string}
     * @memberof ConfigurationInfo
     */
    configurationValue?: string;
}

/**
 * Check if a given object implements the ConfigurationInfo interface.
 */
export function instanceOfConfigurationInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConfigurationInfoFromJSON(json: any): ConfigurationInfo {
    return ConfigurationInfoFromJSONTyped(json, false);
}

export function ConfigurationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'configuratorType': !exists(json, 'configuratorType') ? undefined : json['configuratorType'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'configurationLabel': !exists(json, 'configurationLabel') ? undefined : json['configurationLabel'],
        'configurationValue': !exists(json, 'configurationValue') ? undefined : json['configurationValue'],
    };
}

export function ConfigurationInfoToJSON(value?: ConfigurationInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'configuratorType': value.configuratorType,
        'status': value.status,
        'configurationLabel': value.configurationLabel,
        'configurationValue': value.configurationValue,
    };
}

